import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import MobileUnsupported from '../slices/mobile-unsupported/mobile-unsupported';
import { getFromSessionStorage } from './session-storage-utils';
import {
  AUTH_TOKEN,
  MOBILE_UNSUPPORTED_ROUTES_EXCLUSION_LIST,
} from '../constants/session-storage-keys';
import { isDevMode } from './env-utils';

const getUUID = () => uuidv4();

const getSplitSlice = (str, splitBy, index) => str?.split(`${splitBy}`)[index];

const isEmpty = (val) => val.trim().length === 0;

const getSubMenuItems = (options, pathname) => options.filter(({ link }) => (
  getSplitSlice(link, '/', 1) === getSplitSlice(pathname, '/', 1)
));

const formatDate = (date) => new Date(date).toLocaleDateString('en-GB', {
  day: 'numeric', month: 'short', year: 'numeric',
}).replace(/ /g, '-');

const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};

const checkAnyFilterApplied = (filters) => {
  if (filters) {
    const filterValues = Object.values(filters);
    if (filterValues.length > 0) {
      for (let i = 0; i < filterValues.length; i += 1) {
        if (Array.isArray(filterValues[i]) && filterValues[i].length) {
          return true;
        }
      }
    }
  }

  return false;
};

const filterMobileUnsupportedRoutes = (routes, parentRoute) => {
  if (routes) {
    return routes.reduce((acc, r) => {
      const route = { ...r };
      let path = '';
      if (route.path) {
        path = parentRoute ? `${parentRoute}/${route.path}` : `/${route.path}`;
      }
      const exclusionList = getFromSessionStorage(MOBILE_UNSUPPORTED_ROUTES_EXCLUSION_LIST) || [];
      if (route.isMobileUnsupported && !exclusionList.includes(path)) {
        route.element = <MobileUnsupported />;
      }
      route.children = filterMobileUnsupportedRoutes(route.children, path);
      acc.push(route);
      return acc;
    }, []);
  }
  return routes;
};

export const addCurrentURLParams = (queryParams = {}) => {
  if (!window.location.search) return queryParams;
  const params = {};
  window.location.search
    .replace('?', '')
    .split('&')
    .forEach((param) => {
      const [key, value] = param.split('=');
      params[key] = value;
    });
  return { ...params, ...queryParams };
};

const getRedirectPath = (URL, queryParams, params) => {
  const LOCALHOST_REDIRECT_ENV = 'https://preprod-dashboard.leegality.com';
  const host = window.location.origin;
  let finalURL = URL;
  // Temp logic as we don't want to redirect to preprod for v4 dev
  if (isDevMode() && !queryParams?.workflowId) {
    finalURL = finalURL.replace(host, LOCALHOST_REDIRECT_ENV);
  }
  if (queryParams) {
    finalURL += '?';
    Object.keys(queryParams).forEach((key) => {
      finalURL += `${key}=${queryParams[key]}&`;
    });
    finalURL = finalURL.slice(0, -1);
  }
  if (params) {
    Object.keys(params).forEach((key) => {
      finalURL = finalURL.replace(`:${key}`, params[key]);
    });
  }
  return finalURL;
};

const getRedirect = {
  path: getRedirectPath,
  go: (URL, queryParams, params, target = '_self') => {
    window.open(
      getRedirectPath(URL, queryParams, params),
      target,
      target === '_blank' ? 'noopener,noreferrer' : undefined,
    );
  },
};

const determineMobileView = () => /iPhone|Android/i.test(navigator.userAgent);

const checkUserLoggedIn = () => !!getFromSessionStorage(AUTH_TOKEN);

export {
  getUUID,
  getSplitSlice,
  getSubMenuItems,
  isEmpty,
  formatDate,
  formatBytes,
  checkAnyFilterApplied,
  filterMobileUnsupportedRoutes,
  getRedirect,
  determineMobileView,
  checkUserLoggedIn,
};
